import React from 'react';
import PublicStaticPage from './PublicStaticPage';

const GDPR = () => <PublicStaticPage pageKey="gdpr" />;

export default GDPR;
